export const SOMETHING_WHEN_WRONG = 'Terjadi kesalahan silahkan refresh halaman.'

export const ERROR_INVALID_AUTH_MESSAGE = 'Invalid Authorization'
